<script setup lang="ts">
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const getStyle = (data) => {
  return {
    '--richtext-color': data?.BackgroundColor || 'transparent',
    '--contrast-color': useContrastColor((data?.BackgroundColor || '#fff'), '#fff', '#282827'),
  }
}
</script>

<template>
  <StrapiSlice
    class="ct-richtext-feed"
    :class="{
      'ct-richtext-feed--multiple': slice.Richtexts?.length > 1,
    }"
    :slice="slice"
    :index="index"
  >
    <div
      v-if="slice?.Richtexts?.length"
      class="ct-richtext-feed__grid"
    >
      <div
        v-for="data in slice.Richtexts"
        :key="data"
        class="ct-richtext-feed__richtext"
        :class="`ct-richtext-feed__richtext--${data.TextAlignment || 'left'}`"
        :style="getStyle(data)"
      >
        <StrapiBlocksText
          v-if="data.Richtext?.length"
          :nodes="data.Richtext"
        />

        <AppLink
          v-if="data?.Button?.Text && data?.Button?.Link"
          :to="data?.Button?.Link"
          class="ct-richtext-feed__button"
          :class="`ct-richtext-feed__button--${data?.Button?.Type}${data?.Button?.Small ? '--small' : ''}`"
        >
          <span>{{ data?.Button?.Text }}</span>
        </AppLink>
      </div>
    </div>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/RichtextFeed.css");
</style>
